import { t } from "@lingui/macro";

import { CouponCodeIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Pressable,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type Props = {
  onOpen: () => void;
};

export const CollapsedPromoCodeState = ({ onOpen }: Props) => (
  <VStack gap={3} testID="booking-promo-code">
    <HStack alignItems="center" justifyContent="space-between" width="100%">
      <Pressable
        accessibilityLabel={t`Apply Promo Code`}
        accessibilityRole="button"
        testID="apply-coupon-code-button"
        onPress={onOpen}
        flex={1}
      >
        <HStack alignItems="center" gap={3}>
          <Box
            width={32}
            height={20}
            borderRadius="0.5"
            backgroundColor="surface-main-primary-subtlest"
            alignItems="center"
            justifyContent="center"
          >
            <CouponCodeIcon color="icon-main-primary" width={16} height={16} />
          </Box>
          <Text variant="mainBaseSemiBold" color="text-main-primary">
            {t`Apply Promo Code`}
          </Text>
        </HStack>
      </Pressable>
    </HStack>
  </VStack>
);
